import React, { useEffect } from 'react';
import { FormField } from '../form/FormField';
import { Label } from '../form/Label';
import { MenuItem, Select } from '@material-ui/core';
import { Input } from '../form/Input';
import { useDispatch, useSelector } from 'react-redux';
import { selectClinic, selectFormInfo, selectGoal } from '../../store/registration/registration.selector';
import { selectUser } from '../../store/auth/auth.selector';
import { registrationActions } from '../../store/registration/registration.reducer';
import { RequestType } from '../../model/enums/RequestType';

export const ClinicChoice = () => {
  const user = useSelector(selectUser);
  const goal = useSelector(selectGoal);
  const clinic = useSelector(selectClinic);
  const dispatch = useDispatch();
  const formInfo = useSelector(selectFormInfo);

  useEffect(() => {
    if (clinic?.goals.length === 1) {
      dispatch(registrationActions.setGoal(clinic.goals[0]));
    }
  }, [clinic, dispatch]);

  const handleClinicSelect = (clinicName: string) => {
    const foundClinic = formInfo?.clinics.find(clinic => clinic.name === clinicName);
    if (!foundClinic) {
      return;
    }

    dispatch(registrationActions.setClinic(foundClinic));
  };

  if (!user || !formInfo) {
    return null;
  }

  return (
    <>
      <FormField>
        <Label required={true}>Klinika:</Label>
        <Select value={clinic?.name ?? ''}
                onChange={(e) => handleClinicSelect(e.target.value as string)}
                input={<Input />}>
          {formInfo.clinics.map((clinic, key) =>
            <MenuItem key={key} value={clinic.name}>
              {clinic.name}
            </MenuItem>
          )}
        </Select>
      </FormField>
      {(() => {
        if (user.requestType === RequestType.DoctorRegistration) {
          return <FormField disabled={!clinic}>
            <Label required={true}>Cíl předání pacienta:</Label>
            <Select value={goal ?? ''}
                    onChange={(e) => dispatch(registrationActions.setGoal(e.target.value as string))}
                    input={<Input />}>
              {clinic?.goals.map((goal, key) =>
                <MenuItem key={key} value={goal}>
                  {goal}
                </MenuItem>
              )}
            </Select>
          </FormField>;
        }
      })()}
    </>
  );
};
